// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"511":"63cf03ca","551":"63cf03ca","906":"5df16565"}[chunkId] + ".chunk.css";
};